/*
 * @Description:
 * @Author: 景 彡
 * @Date: 2022-09-29 10:27:20
 * @LastEditors: 景 彡
 */
import Vue from 'vue';
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');

Vue.filter('NumberFormat', function(value: any) {
  if (!value) {
    return '0';
  }
  const intPartFormat = value.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); // 将整数部分逢三一断
  return intPartFormat;
});

export function datetime(value: string, pattern: string = 'YYYY-MM-DD HH:mm:ss'): string | null {
  const result = moment(value).format(pattern);
  if (result === 'Invalid date') {
    return null;
  }
  return result.replace('00:00:00', '');
}
Vue.filter('datetime', function(dataStr: string, pattern: string = 'YYYY-MM-DD HH:mm:ss') {
  return datetime(dataStr, pattern);
});

Vue.filter('date', function(dataStr: string, pattern: string = 'YYYY-MM-DD') {
  return datetime(dataStr, pattern);
});

Vue.filter('month', function(dataStr: string, pattern: string = 'YYYY-MM') {
  return datetime(dataStr, pattern);
});

Vue.filter('fileSize', (bytes: number) => {
  if (!bytes || bytes === 0) {
    return '0 Bytes';
  }
  const k = 1024;
  const dm = 2;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
});
